import { render, staticRenderFns } from "./MyDamageDetailSideCard.vue?vue&type=template&id=571c7063&"
import script from "./MyDamageDetailSideCard.vue?vue&type=script&lang=ts&"
export * from "./MyDamageDetailSideCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports